/* global __CLIENT__ */
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import 'rc-tooltip/assets/bootstrap.css';
import React from 'react';
import '../../../styles/IconNavList.css';
import { default as ConstructionIconNavList, default as DefaultIconNavList } from './industry/construction';


const IconNavList = (
  {
    industryId,
    projectId,
    project,
    userMode,
    icons,
    taskTypeId,
    dispatch,
    flatTaskDsmId,
    ppcGraphId,
    rootCauseGraphId,
    location,
    currentUser,
  },
) => {
  const IconNavListSelection = iconNavListPicker(industryId);
  const accountId = project.getIn(['account_id'], null);
  const accountRole = currentUser.getIn(['roles', 'account', accountId]);
  const isAccountAdmin = (accountRole <= 2);

  return (
    <IconNavListSelection
      currentUser={currentUser}
      industryId={industryId}
      projectId={projectId}
      project={project}
      userMode={userMode}
      icons={icons}
      location={location}
      taskTypeId={taskTypeId}
      flatTaskDsmId={flatTaskDsmId}
      ppcGraphId={ppcGraphId}
      rootCauseGraphId={rootCauseGraphId}
      dispatch={dispatch}
      isAccountAdmin={isAccountAdmin}
    />
  );
};

IconNavList.propTypes = {
  userMode: PropTypes.string,
  industryId: PropTypes.number,
  projectId: PropTypes.string.isRequired,
  project: PropTypes.instanceOf(Map).isRequired,
  icons: PropTypes.instanceOf(Map),
  taskTypeId: PropTypes.string,
  flatTaskDsmId: PropTypes.string,
  ppcGraphId: PropTypes.string,
  rootCauseGraphId: PropTypes.string,
  dispatch: PropTypes.func,
  currentUser: PropTypes.instanceOf(Map),
};

const iconNavListPicker = industryId => {
  let IconNavListSelection;
  switch (industryId) {
    case 1:
      IconNavListSelection = ConstructionIconNavList;
      break;
    default:
      IconNavListSelection = DefaultIconNavList;
      break;
  }
  return IconNavListSelection;
};

export default IconNavList;



// WEBPACK FOOTER //
// ./src/components/toolbars/IconNavList/IconNavList.js